import { createSlice } from "@reduxjs/toolkit";
import {
    setLayerConfig,
    setMapProperties,
    sortLayers,
    createDynamicState,
    setPrintTemplates,
    setStaticBaseMaps,
    setPermissions,
    setThirdPartyMaps,
    getGroupLayers,
} from "./stateChangers";

export const setConfigSlice = createSlice({
    name: "setConfig",
    initialState: {
        layers: undefined,
        vectorLayerProperties: undefined,
        baseMaps: undefined,
        layerVisProperties: undefined,
        groupVisProperties: undefined,
        mapConfig: undefined,
        snappingReady: { ready: false },
        siteLoading: false,
        runningUrlQuery: false,
        urlQuery: undefined,
        printTemplates: undefined,
        thirdPartyBaseMap: undefined,
        permissions: undefined,
        thirdPartyMaps: undefined,
    },
    reducers: {
        setConfigData: (state, action) => {
            state.permissions = setPermissions(action);
            state.layers = setLayerConfig(action);
            state.thirdPartyBaseMap = setStaticBaseMaps(action);
            state.thirdPartyMaps = setThirdPartyMaps(action);
            state.groupVisProperties = getGroupLayers(state.layers);
            const [baseMaps, vectorLayers] = sortLayers(state.layers);
            state.baseMaps = baseMaps;
            state.vectorLayerProperties = vectorLayers;

            const dynamicState = createDynamicState([...baseMaps, ...vectorLayers]);

            state.layerVisProperties = dynamicState;

            state.mapConfig = setMapProperties(action);

            state.printTemplates = setPrintTemplates(action);
        },
        addLayerToVisProperties: (state, action) => {
            const newLayers = createDynamicState([...action.payload]);
            state.layerVisProperties = [...state.layerVisProperties, ...newLayers];
        },
        updateLayerVisible: (state, action) => {
            const [id, visible] = action.payload;
            const index = state.layerVisProperties.findIndex((ids) => ids.Id === id);
            state.layerVisProperties[index].Visible = visible;
        },
        updateGroupVisible: (state, action) => {
            const [DisplayName, visible] = action.payload;
            const index = state.groupVisProperties.findIndex(
                (disNs) => disNs.DisplayName === DisplayName
            );
            state.groupVisProperties[index].Visible = visible;
        },
        updateSnappable: (state, action) => {
            const [id, snappable] = action.payload;
            const index = state.layerVisProperties.findIndex((ids) => ids.Id === id);
            state.layerVisProperties[index].Snappable = snappable;
        },
        updateLayerOpacity: (state, action) => {
            const [id, opacity] = action.payload;
            const index = state.layerVisProperties.findIndex((ids) => ids.Id === id);
            state.layerVisProperties[index].Opacity = opacity;
        },
        setProjectionInfo: (state, action) => {
            state.projectionInfo = action.payload;
        },
        setSnappingReady: (state, action) => {
            state.snappingReady = { ready: action.payload };
        },
        setSiteLoading: (state, action) => {
            state.siteLoading = action.payload;
        },
        setUrlQuery: (state, action) => {
            state.urlQuery = action.payload;
        },
        setRunningUrlQuery: (state, action) => {
            state.runningUrlQuery = action.payload;
        },
    },
});

export const {
    setConfigData,
    addLayerToVisProperties,
    updateLayerVisible,
    updateGroupVisible,
    updateSnappable,
    setSnappingReady,
    updateLayerOpacity,
    setSiteLoading,
    setUrlQuery,
    setRunningUrlQuery,
} = setConfigSlice.actions;

export default setConfigSlice.reducer;
